import type { DataErrorRepository } from '../data/data-error-repository';
import type { HandleType } from '../types/data-error-types';

export class HandleIrregularDeltaUseCase {
  constructor(private readonly repository: DataErrorRepository) {}

  async execute(
    irregularId: number,
    handleType: HandleType,
    comment: string | null
  ): Promise<{ isSuccess: true } | { isSuccess: false; errorMessage: string }> {
    try {
      const result = await this.repository.handleAction({ irregularId, handleType, comment });
      if (!result.isSuccess) {
        return { isSuccess: false, errorMessage: result.errorMessage ?? 'Action failed' };
      }
      return { isSuccess: true };
    } catch (error: unknown) {
      return {
        isSuccess: false,
        errorMessage: error instanceof Error ? error.message : 'Action failed',
      };
    }
  }
}
